<template>
  <div class="" :value="value" v-show="showPop">
    <van-dialog
      v-model="showPop"
      show-cancel-button
      confirmButtonText="保存"
      @confirm="add"
    >
      <van-cell-group>
        <van-cell title="产品分类" @click="showType=!showType">
          <p class="item2 date-time black" v-if="obj.U_ProductClass1">{{obj.U_ProductClass1}}</p>
          <p class="item2 date-time" v-else>选择产品一级分类</p>
          <div slot="right-icon"  class="triangle_border_down" />
        </van-cell>
        <van-cell title="名称">
          <van-field   placeholder="请输入名称" class="item2" v-model="obj.U_ProductName" @input="limitLength(100,'obj','U_ProductName')"/>
        </van-cell>
        <van-cell title="金额">
          <van-field type="number"  placeholder="请输入金额" class="item2" v-model="obj.U_Amount"/>
        </van-cell>
      </van-cell-group>
    </van-dialog>
    <van-popup v-model="showType" position="bottom" :overlay="true">
      <van-picker
        show-toolbar
        :columns="pickerList"
        value-key="name"
        @confirm="typeChange"
        @cancel="showType = !showType"
      />
    </van-popup>
  </div>
</template>
<script>
  export default{
    data(){
      return {
        obj:{
          productClass1Name:'',  //物料类别
          U_ProductName : '',
          U_Amount : "",
          U_ProductClass1:''
        },
        showPop:false,

        showType:false,
        pickerList:[
          {
            name:'请选择',
            value:''
          }
        ],
      }
    },
    props:{
      value:{
        type:Boolean,
        default:false
      },
      info:{}
    },
    watch:{
      value(val){
        this.showPop = val
      },
      showPop(val){
        if(!val){
          this.obj={
            productClass1Name:'',  //物料类别
            U_ProductName : '',
            U_Amount : "",
            U_ProductClass1 : ""
          }
        }else if(this.info){
          this.obj=$.extend(true,{},(this.info || {}),{
            U_Sort:this.info.U_Sort,
            U_ProductName : this.info.U_ProductName,
            U_Amount:this.info.U_Amount,
            productClass1Name:this.info.U_ProductClass1 || this.info.productClass1Name,
            U_ProductClass1 : this.info.U_ProductClass1 || this.info.productClass1Name
          });
        }
        this.$emit('input',val)
      },
      'obj.U_Amount':function(newVal,oldVal){
          if(newVal){
            this.obj.U_Amount=this.$validator().towDecimal(newVal+'')
          }
      }
    },
    methods:{
      getCols(){
        this.$api.getQueryByTcode({
          tcode:'Products1stType'
        }).then(response=>{
          this.pickerList =this.pickerList.concat(response.data)
        })
      },
      typeChange(e){
        this.showType=!this.showType
        if(!e.value){
              return
          }
        this.obj.U_ProductClass1 = e.name
      },
      add(){
        if(!this.obj.U_ProductName){
          this.$title('请输入名称')
          return
        }else if(!this.obj.U_ProductClass1){
          this.$title('请选择产品分类')
          return
        }else if(!this.obj.U_Amount){
          this.$title('请输入金额')
          return
        }
        this.$emit('newSales',this.obj)
      },
      limitLength(len,key1,key2){
        let value = ''
        if(key2){
          value =this.$data[key1][key2]
        }else{
          value =this.$data[key1]
        }
        if(value.length>len){
          if(key2){
            this.$data[key1][key2]=value.slice(0,len)
          }else{
            this.$data[key1]=value.slice(0,len)
          }
        }
      }
    },
    created(){
      this.getCols()
    }
  }
</script>
<style scoped lang="less" rel="stylesheet/less">
  @import "../../../style/pageStyle/pageView-activeDetail.less";
  .van-cell__title{
    width:60px;
  }
  .van-cell__value{
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/active/component/salesPop.vue